const apiVersionBV = "5.4"
const staticClasses = {
  CONTAINER: "container responsivegrid",
}
const CONSTANTS = {
  DEFAULT_IDLE_TIMEOUT: 172800, // In Seconds
  DEFAULT_VERSION: "v1",
  ERROR_CODES: {
    BAD_REQUEST_ERROR: 400,
    INTERNAL_SERVER_ERROR: 500,
    AUTHENTICATION_ERROR: [401, 403],
  },
  USER_STATE: {
    LOGGED_USER: "logged",
    ANONYMOUS_USER: "anonymous",
  },
  PARENT_COMPONENTS_LIST: {
    ORDER_DETAILS: "OrderDetails",
  },
  PAYMENT: {
    SUCCESS_CODE: "870",
    NUM_YEARS: 16,
  },
  ORDER_STATUS_SHIPPED: "Shipped",
  DELETE_INACTIVE_MYFOLDER_AFTER: 30,
  ERROR_MESSAGE: {
    GENERAL: "Something went wrong. Please try again...",
    SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
    SESSION_TIMEOUT_SECURE_PAGE_MSG:
      "Redirecting to Home Page due to inactivity",
  },
  COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/", // TODO: Obtain value from config
  CT_API_URL: "https://api.us-central1.gcp.commercetools.com", // TODO: Obtain value from config
  CT_PROJECT_KEY: "kohler-na-qa-1", // TODO: Obtain value from config
  CT_SALES_CHANNEL: "KOUS", // TODO: Obtain value from config
  REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
  REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
  REGEX_PASSWORD: new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"
  ),
  REGEX_EMAIL:
    /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
  KEYCODE: { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 },
  KEY: { ENTER: "Enter", ESC: "Escape" },
  FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
  KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
  KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
  KF_UPDATE_MEMBERSHIP: "kf-update-membership",
  CREATE_ACCOUNT_TYPE: {
    HOME_OWNER: "homeowner",
    PROFESSIONAL: "professional",
  },
  UNDEFINED: "undefined",
  COMPONENT: {
    PAIRS_WELL_WITH: "pairsWellWith",
  },
  SLICK: {
    DEFAULT_DELAY: 5000,
    COUNT_OFFSET: 20,
    ARROW_OFFSET: 42,
  },
  CURRENCY_SIGN: "$",
  STATUS: {
    OK: 200,
    PAGE_NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },
  REGEX_CONTAINS_LETTER: /[a-z]/i,
  BROWSER_NO_AUTOFILL: "no-autofill",
}

const annSacksConstants = {
  asBrandName: "annsacks",
  asBrandNameWithCase: "AnnSacks",
  asSourceChannel: "asus",
}

const SWATCH_NA = "swatch_NA"
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked"
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount"
const maxAppReached = "MaxApplicationReached"
const discountMatchesCart = "MatchesCart"
export const STOPPED_BY_PREVIOUS_DISCOUNT = stopedByPreviousDiscount
export const MAX_APPLICATION_REACHED = maxAppReached
export const DISCOUNT_MATCHES_CART = discountMatchesCart
// Membership
// Store Appointment
// Return Slips

export const PAYPAL_TYPES = ["PP", "Paypal", "PAYPAL", "PayPal", "paypal"]
export const CARD_TYPES = ["CREDIT_CARD", "credit_card", "CARD", "card"]
export const PCIPAL_TYPES = ["PCIPAL", "PciPal", "pcipal", "PCIPal", "PCI_Pal"]

export const CATEGORY_LANDING_PAGE = "category-landing-page"

const COMPONENT_TYPES = {
  AEMFORM: "aemform",
  PRODUCTCARD: "productcard",
  ROOT_CONTAINER: "root",
  CONTAINER: "container",
  VIDEO: "video",
  AUTH_MODAL: "authmodal",
  NEWSLETTER: "newsletter",
  TEASER: "teaser",
  CAROUSEL: "carousel",
  SLICK: "carousel-slick",
  SPACER: "spacer",
  TEXT: "text",
  TAB: "tab",
  GLOBAL_TOASTER: "globalToaster",
  BREADCRUMB: "breadcrumb",
  PRODUCTLIST: "productlist",
  SEARCH: "search/v1/search",
  EMBED: "embed",
  BRAND_SWITCHER: "brand-switcher",
  UTILITY_NAV_HEADER: "utilitynavheader",
  UTILITY_WIDGET: "utilitywidget",
  TABS: "tabs",
  IMAGE: "image",
  SITEWIDE_WARNING: "sitewide-warning",
  IMAGEV3: "image/v3/image",
  CAROUSELSLICK: "carousel-slick",
  TOASTER: "toaster/v1/toaster",
  COMPARE_PRODUCTS: "compareproducts",
  MAIN_FOOTER: "mainfooter",
  ADDITIONAL_FOOTER: "additionalfooter",
  NEWSLETTER_SIGNIN: "newslettersignin",
  NEWSLETTER_SIGNUP: "newslettersignup",
  CART_LANDING: "cart-landing",
  CHECKOUT: "checkout",
  ORDER_CONFIRMATION: "orderconfirmation",
  ORDER_STATUS: "orderstatus",
  ORDER_HISTORY: "orderhistory",
  ORDER_DETAILS: "orderdetails",
  SHARED_CART: "sharedcart",
  PAIRS_WELL_WITH: "pairs-well-with",
  HELPSUPPORT: "help-support",
  GLOBAL_NAVIGATION: "globalnavigation",
  PROMOBANNER: "plp-promo-banner",
  ACCOUNT_SETTINGS: "accountsettings",
  MY_SERVICES: "myservices",
  MY_FAVORITES: "myfavorites",
  CHANGE_PASSWORD: "changepassword",
  MY_PRODUCTS: "myproducts",
  PRODUCT_DETAILS: "pdp/v1/pdp",
  PRODUCT_DETAILS_ACCORDION: "accordion",
  PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
  PRODUCT_DETAILS_REVIEW: "components/review",
  REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
  REGISTER_ONLINE_PRODUCTS: "register-online-products",
  KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
  BROWSE_ALL_STORES: "browseallstores",
  STORE_FILTER: "storefilter",
  LITERATURE: "literature",
  CONTACT_US: "contactus",
  FINDING_MODEL_NUMBER: "finding-model-number",
  TECHNICAL_SPECIFICATION: "technicalspecs",
  PRESS_LANDING: "press-release-landing",
  UPSELL_CONTAINER: "container-up-sell",
  FIND_STORE: "findstore",
  INPAGE_SEARCH: "in-page-search",
  TITLE: "title",
  KEY_SPECIFIER: "key-specifier",
  DYNAMIC_SEARCH: "dynamicsearch",
  ASSOCIATE_MEMBERSHIP: "associate-membership",
  INSPIRE_VIDEO: "inspire-video",
  IMAGE_CLUSTER: "imagecluster",
  SHOP_THE_ROOM_CARD: "shoptheroomcard",
  INSTALL_DESIGN_SERVICES: "v1/installdesignservices",
  PROFESSIONAL_DETAILS: "professional-detail",
  FRIENDS_AND_FAMILY: "friends-family",
  FIND_A_PRO_BY_ZIP: "find-pro-by-zip",
  FIND_A_PRO_RESULTS: "find-a-pro-results",
  LIST: "list",
  STORE_APPOINTMENT: "store-appointment",
  PRODUCTCARD_V3: "productcard-v3",
  SHOP_THE_ROOM_DETAIL: "shoptheroomdetail",
  ROOM_DETAIL: "roomdetail",
  GATED_CONTENT: "gated-content-paths",
  PRODUCT_CARD_V4: "productcard-v4",
  PDP_CURATED_PRODUCTS: "pdp-curated-product",
  PDP_CURATED_RECOMMENDATION: "target-recommendations",
  SHOP_THE_ROOM_PAGE: "shoptheroomlist",
  NAVIGATION_V3: "v3/globalnavigation",
  Lead_Generation: "leadgenform",
  VISUAL_NAV_FILTER: "visual_nav_filter",
  VISUAL_NAV_APPLIEDCLASS: "visual-nav",
  PRODUCT_SLIDER: "productslider",
  RETURN_SLIP: "returnslip",
}

const VIDEO_EVENTS = {
  PLAY: "play",
  PAUSE: "pause",
  ENDED: "ended",
  VIDEO_PLAY: "video play",
  VIDEO_PAUSE: "video pause",
  VIDEO_VIEWED: "video viewed",
  VIDEO_COMPLETE: "video complete",
  VIDEO_CLICK: "videoClick",
  PLAY_VIDEO: "videoPlay",
  PAUSE_VIDEO: "videoPause",
  CLOSE_VIDEO: "videoClose",
  CLOSE: "close",
}
export const VIDEO_PROGRESS_MILESTONES = [25, 50, 75, 100]

const KEYCODE = { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 }
// Find a store
export const FINDLOCATIONKEYCODE = { LEFTARROW: 37, RIGHTARROW: 39 }
export const FIND_LOCATION_KEYCODE = FINDLOCATIONKEYCODE
export const LOCATIONSCONST = {
  LocationType: "KOHLER Store",
  paramSpatialFilter: 161,
  status: 200,
}
export const LOCATIONS_CONST = LOCATIONSCONST

const queryParamsToPersist = ["sort", "keyword", "tab"]

const customActivityEvents = ["click", "keydown"]

const PAGE_TYPES = {
  CATEGORY_LANDING_PAGE: "category landing page",
  SHARE_CART_LANDING_PAGE: "share cart landing page",
  LOCATION_LANDING_PAGE: "landing:location info",
}
const PRODUCTS_PER_PAGE = [30, 60, 90]
const imgPlaceholderData =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
// Account Settings constants

export const EMPTY_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
export const FULL_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

export const EMPTY_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,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"

const TABS_NOT_REQUIRED_GRIDICON = [
  "inspiration",
  "technical",
  "resources",
  "help",
]
// myProducts endPoints

const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts"
const PARTS = "parts"

// contact us endpoints

export const API_SUCCESS_STATUS = "succeeded"
export const API_FAILURE_STATUS = "failed"
export const EMBED_TYPE_SCRIPT = "SCRIPT"
export const EMBED_TYPE_HTML = "HTML"
export const VISUALICON_ARIA_LABEL = "View at 360 degree mode"
export const MATTERPORT_ARIA_LABEL = "virtual tour popup"
export const MATTERPORT_IFRAME_TITLE = "3D room viewer"

// tab component constants
export const NS = "cmp"
export const IS = "tabs"
export const keyCodes = {
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
}
export const selectors = {
  self: "[data-" + NS + '-is="' + IS + '"]',
  active: {
    tab: "cmp-tabs__tab--active",
    tabpanel: "cmp-tabs__tabpanel--active",
  },
}
export const MIN_VIDEO_DURATION = 5
// privacy-policy constants
export const PRIVACY_ASPATH = "privacy-policy"

// press room constants
export const DOWNLOAD_SPINNER = "download-spinner"

// teasercaption-repositioning constants
export const TEASER_CAPTION_CLASSES =
  ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number"

// Add conditional wrapper in AEMGRID component for the provided grouped elements.
export const groupedComponents = [
  COMPONENT_TYPES?.BREADCRUMB,
  COMPONENT_TYPES?.CAROUSEL,
]
export const SUCCESS = "success"

export const resourceFacetLabels = [
  "ResourceVntanaProductId_s",
  "ResourceVntanaProductIdList_ss",
  "ResourceNvznIdList_ss",
  "ProductIsExclusive_s",
  "RegionSoldOnline_s",
  "CustomerFacingBrand_s",
  "ProductBusinessUnit_ss",
  "BundlePLPImageURL_s",
  "ctProductType_s",
  "colorSkuSlugListDetails_ss",
  "sku_slug_color_swatch_image",
  "sku_instock_customerfacingsku_slug_color_swatch_image",
  "RegionReleaseforShipment_dt",
]

export const DEVICE_TYPE_DESKTOP = "desktop"

// shop the room details page
export const SHOP_THE_ROOM = "shop-the-room"

export const COUNTRY = {
  US: "US",
}

// bazaar voice constants
export const BAZAAR_VOICE = "bazaarvoice"

// Redirect constants
export const VANITY_REDIRECT_TYPE = "Vanity"

// teasercaption-repositioning constants
export const TEASER_CAPTION_CLASSES_LIST = [
  "img-right-caption-left",
  "img-right-caption-left mobile-cta-double",
  "mobile-cta-double img-right-caption-left",
  "img-right-caption-left mobile-cta-single",
  "history-module-vertical-image image-right",
  "history-module-with-SQR-img image-left",
  "img-caption-style-left img-right-with-number__intend",
  "img-caption-style-left img-right-with-number",
]

export const GATED_HASHES = ["#login", "#signup", "#createaccount", "#signin"]
export const FRAUD_CHLLENGE_STATUS = ["CHALLENGE", "ERROR", "DENY"]
export const FRAUD_CHALLENGE_STATUS = FRAUD_CHLLENGE_STATUS
export const IN_REVIEW_ORDER_STATUS = [
  "PA_PENDING",
  "ERROR_STATE",
  "FRAUD_HOLD",
  "FRAUD_CANCELLED",
]
export const ORDER_IN_RECEIVED_STATUS = ["RECEIVED", "CREATED"]

export const myListContainerBreakPoints = {
  default: 3,
  1920: 3,
  1599: 2,
  639: 1,
}

export const MONTH_NAMES_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const MONTH_NAMES_FR = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
]

export const NODE_NAMES = {
  BUTTON: "BUTTON",
  IMG: "IMG",
}

export const ONETRUST_IDENTIFIER = "cookielaw"

export const SEARCH_TABS = {
  PRODUCTS: "Products",
  PARTS: "Parts",
  INSPIRATION: "Inspiration",
  TECHNICAL: "Technical",
  RESOURCES: "Resources",
  HELP: "Help",
}

export const INITIAL_SEARCH_TABS_COUNT = {
  [SEARCH_TABS.PRODUCTS]: 0,
  [SEARCH_TABS.PARTS]: 0,
  [SEARCH_TABS.INSPIRATION]: 0,
  [SEARCH_TABS.TECHNICAL]: 0,
  [SEARCH_TABS.RESOURCES]: 0,
  [SEARCH_TABS.HELP]: 0,
}

export {
  staticClasses,
  apiVersionBV,
  SWATCH_NA,
  PRIVACY_COOKIE_CLICKED,
  stopedByPreviousDiscount,
  maxAppReached,
  discountMatchesCart,
  COMPONENT_TYPES,
  VIDEO_EVENTS,
  KEYCODE,
  queryParamsToPersist,
  customActivityEvents,
  PAGE_TYPES,
  PRODUCTS_PER_PAGE,
  imgPlaceholderData,
  TABS_NOT_REQUIRED_GRIDICON,
  PLUMBING_SERVICE_PARTS,
  PARTS,
  annSacksConstants,
}
export const SEAT_TYPES = ["Toilet Seats", "Bidet Seats"]
export const EXCLUDE_PAGES = ["/checkout"]
export const UTILITY_CONSTANTS = {
  FAVOURITES: "favourite",
  SHARE: "share",
  PRINT: "print",
  DOWNLOAD: "download",
}
export const TEASER_CLASSES = ["hero-banner-full-bleed-image", "hero-video-3-4"]
export const SHOP_THE_ROOM_CLASSES = ["shop-the-room"]
export default CONSTANTS
export const ADDRESS_SUGGESTION_DEFAULT_COUNTRY = "USA"
export const AFFIRM_SHOP_URL = "https://www.affirm.com/shop/kohler-web"

export const FREIGHT_SHIPPING_TYPES = ["Freight", "Freight Shipping"]

export const SEARCH_PDP_FL = [
  "id",
  "sku_s",
  "ctId_s",
  "ProductWaterSense_ss",
  "masterSKU_s",
  "CustomerFacingSKU_s",
  "ProductProductRecommendedAccessories_ss",
  "Product_Category",
  "ProductLocalCategory_s",
  "ProductServices_ss",
  "ProductPriceSpiderIncluded_s",
  "SKUIsProjectPack_s",
  "ProductBrandNameDisplay_s",
  "Collapse_Field_s",
  "Color.SKU.Details_ss",
  "productName_s",
  "RegionBrandName_s",
  "variantList.sku_ss",
  "ProductRequiredAccessoryGroup_ss",
  "ProductYoutubeID_s",
  "productImages.labelWithUrl_ss",
  "ProductDescriptionProductShort_s",
  "productRegionAllVariantDiscontinued_b",
  "ProductBrandName_s",
  "RegionOnBackOrder_s",
  "ProductOverallLengthInches_s",
  "ProductOverallWidthInches_s",
  "ProductOverallHeightInches_s",
  "ProductWebFeatures_ss",
  "ProductFreightPolicyType_s",
  "category1_s",
  "RegionReleaseforShipment_dt",
  "priceList.*.finalPrice_d",
  "priceList.*.saleOffer_s",
  "priceStartingAt.*_d",
  "priceList.*.discountedPrice_d",
  "priceList.*.price_d",
  "ProductBadgeInfo_ss",
  "ProductWebTechnology_ss",
  "ProductNarrativeDescription_s",
  "ProductWebMaterial_ss",
  "ProductWebInstallation_ss",
  "ProductCaliforniaProp65WarningDisclaimer_s",
  "ProductWebHydrotherapy_ss",
  "ProductWebRebates_ss",
  "ProductResource.DXFPlanView.resourceFullWebURL_ss",
  "ProductResource.DWGPlanView.resourceFullWebURL_ss",
  "ProductResource.DXFFrontView.resourceFullWebURL_ss",
  "ProductResource.DWGFrontView.resourceFullWebURL_ss",
  "ProductResource.DXFSideView.resourceFullWebURL_ss",
  "ProductResource.DWGSideView.resourceFullWebURL_ss",
  "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
  "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
  "ProductResource.3DRevit.resourceFullWebURL_ss",
  "ProductResource.3D3DS.resourceFullWebURL_ss",
  "ProductResource.3DSketchup.resourceFullWebURL_ss",
  "ProductResource.3DOBJ.resourceFullWebURL_ss",
  "ProductResource.CutOutDXF.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceTitle_ss",
  "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
  "ProductResource.EnvironProdDecl.resourceTitle_ss",
  "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
  "ProductResource.HomeownersGuide.resourceTitle_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
  "SKUDiscontinuedDate_dt",
  "ProductResource.YouTubeInstallVideo.resourceName_ss",
  "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ProductProductNo_s",
  "ctProductType_s",
  "CustomerFacingBrand_s",
  "isCollapsedPDP_b",
  resourceFacetLabels.join(","),
  "CrossSellRecommendationSKUList_ss",
  "primaryBundleSKU_s",
  "bundleSKUList_ss",
  "title_s",
  "features_s",
  "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
  "ItemResource.IMGSpinSet.resourceName_ss",
  "ItemResource.IMGSpinSet.resourceAltText_ss",
  "ItemResource.IMGSpinSet.resourceType_ss",
  "productLocalCategoryBreadCrumb_s",
  "productImages.url_ss",
  "ProductResource.DeclareLabel.resourceFullWebURL_ss",
  "ProductResource.DeclareLabel.resourceType_ss",
]

export const SSR_PLP_FL = [
  "id",
  "masterSKU_s",
  "sku_s",
  "RegionSoldOnline_s",
  "ctProductType_s",
  "productRegionAllVariantDiscontinued_b",
  "CustomerFacingBrand_s",
  "ProductBusinessUnit_ss",
  "masterCustomerFacingSKU_s",
  "SKUColorSwatchFilename_ss",
  "SKUColorSwatchFilename_s",
  "ProductDescriptionProductShort_s",
  "ProductBrandName_s",
  "metaTitle_s",
  "productName_s",
  "RegionBrandName_s",
  "productImages.url_s",
  "productImages.url_ss",
  "slug_s",
  "Product_Category",
  "displayPriceStartingAt_s",
  "Tile_Title",
  "Collapse_Title_s",
  "Collapse_Description_s",
  "price*",
  "discountedPrice*",
  "variantList.sku_ss",
  "variantList.sku_s",
  "SKUColorFinishName_s",
  "SKUColorFinishName_ss",
  "SKU.Details_ss",
  "Color.SKU.Details_ss",
  "ProductExclusive_s",
  "RegionReleaseforShipment_dt",
  "productImages.labelWithUrl_ss",
  "productImages.labelWithUrl_s",
  "productImageVariantImages.labelWithUrl_ss",
  "RegionOnBackOrder_s",
  "ProductIsRetail",
  "comboSKUAvailable_b",
  "category1_s",
  "ProductBrandNameDisplay_s",
  "ctId_s",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductProductNo_s",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ResourceNvznId_s",
  "ResourceVntanaProductId_s",
  "ResourceVntanaProductIdList_ss",
  "ResourceNvznIdList_ss",
  "ProductIsExclusive_s",
  "Collapse_Field_s",
  "primaryBundleSKU_s",
  "disc_max_price",
  "max_price",
  "RegionIsBackOrderable_b",
  "ProductIsRetail_s",
  "ProductWebFeatures_ss",
  "RegionSoldOnline_s",
  "ProductBusinessUnit_ss",
  "CustomerFacingBrand_s",
  "*.Details_ss",
  "disc_min_price",
  "BundlePLPImageURL_s",
  "Bundle_s",
  "displayPriceStartingAt_s",
  "*.minPrice_d",
  "*.maxPrice_d",
  "*.discMaxPrice_d",
  "*.discMinPrice_d",
  "colorSkuSlugListDetails_ss",
  "sku_slug_color_swatch_image",
  "sku_instock_customerfacingsku_slug_color_swatch_image",
]

export const FEATURE_FLAGS_CHECKOUT_PAYLOAD = [
  "MYSQLCONNSTR_ACI_PAYMENT_FLAG",
  "MYSQLCONNSTR_ACI_GLOBAL_PAYMENT_FLAG",
  "MYSQLCONNSTR_DISABLE_ADD_CART",
  "MYSQLCONNSTR_EXCLUDE_PO_BOX_ADDRESSES",
  "MYSQLCONNSTR_DISABLE_BILLING_CUSTOM_DROPDOWN",
  "MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2",
  "MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS",
  "MYSQLCONNSTR_ENABLE_NARVAR_RETURN",
  "MYSQLCONNSTR_ENABLE_PAYPAL_EXPRESS_CHECKOUT",
  "MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2",
  "MYSQLCONNSTR_ENABLE_SAVE_TO_LIST_FOR_QUICK_VIEW",
  "MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1",
  "MYSQLCONNSTR_ENABLE_CONFIGURATOR",
  "MYSQLCONNSTR_ENABLE_CHECKOUT_V2",
  "MYSQLCONNSTR_ENABLE_ALBY_FOR_PERSONAS",
  "MYSQLCONNSTR_ENABLE_ACI_CREDIT_CARD_V2",
  "MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1",
  "MYSQLCONNSTR_ENABLE_EXECUTING_ORDER_LOGGING_API",
  "MYSQLCONNSTR_ENABLE_PDP_AFFIRM",
  "MYSQLCONNSTR_ENABLE_ACI_ELAVON_FLOW",
  "MYSQLCONNSTR_OKTA_TIMEOUT_MINUTES",
]

export const EXCEPTIONAL_SITENAME = "kohler"

export const STORE_APP_LD_JSON = {
  context: "https://schema.org",
  type: "Store",
  addressType: "PostalAddress",
  geoType: "GeoCoordinates",
  openingHourType: "OpeningHoursSpecification",
  openingDays: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
}

export const BREAD_CRUMB_APP_LD_JSON = {
  context: "https://schema.org",
  breadcrumbList: "breadcrumbList",
  listItemType: "ListItem",
}

export const PDP_SLIDER_SIZES = {
  largeIpadSize: 1024,
  largeMinIpadSize: 1023,
  mobileSize: 767,
  desktopSliderImages: 15,
  smallesIpadSliderImages: 12,
  imageReelTitle: "image reel",
  portateDevice: 812,
  visualNavPlp: 1023,
}

export const HEADER_NAV_TABS_WRAPPER_ID = "header-nav-tabs-wrapper"
export const TARGETED_DOMAIN_TO_MONITOR = "kohlermetrics"
export const INSPIRATION_PAGE_NAME = {
  KIPS_BAY_DECORATOR: "kips bay decorator showhouse gallery dallas",
  PROJECT_GALLERY: "project gallery",
  ABOUT_US_OUR_IMPACT: "about us:our impact",
}
export const DB_NAME = "ProductListDB"
export const DB_VERSION = 1
export const STORE_NAME = "plpCardsData"
export const READ_WRITE = "readwrite"
export const READ_ONLY = "readonly"
export const INDEXEDDB_NOT_SUPPORTED_ERROR =
  "IndexedDB is not supported in this browser"
export const METRIC_THRESHOLDS = {
  LCP: [2500, 4000],
  FID: [100, 300],
  CLS: [0.1, 0.25],
  FCP: [1800, 3000],
  TTFB: [800, 1800],
}

export const VNTANA_EMBED_BASE_URL =
  "https://embed.vntana.com?productUuid={pUuid}&clientSlug=kohler&organizationSlug=kohler&autoAR=true"
export const VANTANA_URL_ANDROID = `intent://arvr.google.com/scene-viewer/1.0?file={glburl}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`
export const VNTANA_API_BASE = "https://api.vntana.com"

// Stale build asset recovery - detects chunk load failures during deployments
export const STALE_BUILD_SESSION_KEY = "kohlerStaleBuildAssetReloaded"

export const EXCLUDED_FILTERS = [
  "New_Products",
  "Hide_Discontinued",
  "Products",
  "Inspiration",
  "Technical",
  "Resource",
  "Resources",
  "Help",
  "Parts",
]

export const ALLOWED_SOCIAL_LINKS = ["facebook", "twitter", "linkedin", "x"]
